
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.73 9.84l-1.043-.201a1.802 1.802 0 01-1.345-1.118 1.802 1.802 0 01.225-1.735l.655-.893a.333.333 0 00-.033-.432l-1.414-1.414a.333.333 0 00-.423-.04l-.88.595a1.808 1.808 0 01-2.809-1.225l-.167-1.095a.332.332 0 00-.33-.282h-2a.334.334 0 00-.327.27L9.58 3.619A1.82 1.82 0 017.795 5.09c-.359 0-.709-.109-1.011-.314l-1.136-.77a.334.334 0 00-.423.041L3.811 5.461a.334.334 0 00-.033.433l.654.893c.37.504.454 1.152.226 1.734-.229.582-.731 1-1.345 1.118l-1.043.2a.333.333 0 00-.27.328v2c0 .164.12.304.283.329l1.094.168a1.803 1.803 0 011.386 1.067c.25.573.19 1.224-.161 1.742l-.595.88a.333.333 0 00.04.422l1.414 1.414c.116.116.3.131.433.033l.893-.654a1.789 1.789 0 011.065-.353 1.82 1.82 0 011.787 1.472l.2 1.043c.03.156.168.27.328.27h2c.164 0 .304-.12.329-.283l.118-.77c.156-1.01 1.023-1.539 1.799-1.539.382 0 .75.122 1.065.354l.628.46a.333.333 0 00.433-.033l1.414-1.414a.333.333 0 00.04-.423l-.595-.88a1.804 1.804 0 01-.16-1.741c.25-.573.767-.972 1.385-1.067l1.094-.168a.333.333 0 00.283-.33v-2a.333.333 0 00-.27-.327zM14 11.166A2.837 2.837 0 0111.167 14a2.837 2.837 0 01-2.834-2.833 2.837 2.837 0 012.834-2.834A2.837 2.837 0 0114 11.167z"}})])
          )
        }
      }
    